import React from "react";
import { Col as ANTCol, Flex } from "antd";
import styled from "styled-components";
import dayjs from "dayjs";

export const Col = styled(ANTCol)`
  &:hover {
    background-color: ${({ theme }) => theme.colors.successBg};
  }
`;

export const ModalTaskRow: React.FC<any> = ({
  rowData,
  setOpen,
  setReservationId,
}) => {
  return (
    <Col
      style={{
        width: "100%",
        padding: "10px",
        borderTop: "1px solid var(--color-border)",
        borderLeft: "1px solid var(--color-border)",
        borderRight: "1px solid var(--color-border)",
        cursor: "pointer",
      }}
      onClick={() => {
        setReservationId(rowData.id);
        setOpen(true);
      }}
    >
      <Flex
        style={{
          width: "100%",
          justifyContent: "space-between",
        }}
      >
        <div>
          {dayjs.utc(rowData.startTime).format("HH:mm")} -{" "}
          {rowData.details?.cart?.[0]?.cart_positoin?.meal_name}
        </div>
        <div>
          {rowData.status === "REJECTED" ? (
            <span style={{ color: "var(--color-text-secondary)" }}>Odrzucona</span>
          ) : rowData.status === "ACCEPTED" ? (
            <span style={{ color: "var(--color-success)" }}>Zatwierdzona</span>
          ) : (
            <span style={{ color: "var(--color-error)" }}>Oczekuje na zatwierdzenie</span>
          )}
        </div>
      </Flex>
    </Col>
  );
};
